import React from 'react';
import {
  AUTH_RECOVERY_FOOTER_TEXT,
  AUTH_RECOVERY_HELP_TEXT,
  AUTH_RECOVERY_TITLE,
} from '../utils/authRecovery';

export default function AuthRecoveryPanel({
  title = AUTH_RECOVERY_TITLE,
  helperText = AUTH_RECOVERY_HELP_TEXT,
  footerText = AUTH_RECOVERY_FOOTER_TEXT,
  isResetting = false,
  onReload,
  onResetLocalSession,
}) {
  return (
    <div
      className="mt-6 rounded-2xl border border-amber-200 bg-amber-50/80 p-5 text-left"
      role="alert"
      aria-live="polite"
    >
      <p className="text-sm font-semibold text-slate-900">{title}</p>
      <p className="mt-2 text-sm leading-6 text-slate-700">{helperText}</p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          onClick={onReload}
          className="inline-flex min-h-11 flex-1 items-center justify-center rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-800 shadow-sm transition hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-100 focus-visible:ring-offset-1"
        >
          Reload
        </button>
        <button
          type="button"
          onClick={onResetLocalSession}
          disabled={isResetting}
          className="inline-flex min-h-11 flex-1 items-center justify-center rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-100 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {isResetting ? 'Resetting...' : 'Reset local session'}
        </button>
      </div>
      {footerText ? <p className="mt-3 text-xs leading-5 text-slate-600">{footerText}</p> : null}
    </div>
  );
}
